export default "__VITE_ASSET__CoaT55vn__"